module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAaCAMAAACJtiw1AAAAM1BMVEVHcEzMzMzMzMzMzMzKysrMzMzMzMzMzMzNzc3MzMzMzMzOzs7MzMzLy8vNzc3Nzc3MzMwDENdJAAAAEHRSTlMAQTiWA6iJ8yfmtQYRY2DMy/riDgAAAEdJREFUGNNjYGDg4WBAATz87EwoAlwCAqgiHJxoIixEiEB0MdJJhB3NdjYBAQEubsr4rHj4zCA+C/l8Bl40PgMDHzMqHw0AAOfNBaP2Ss2DAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/getinto.png
// module id = VuV5
// module chunks = 0